import { ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { SupplierContractStore } from '../stores/supplier-contracts.store';

export const supplierContractLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const supplierContractsStore = inject(SupplierContractStore);
  const supplierContractId = route.paramMap.get('supplierContractId');
  if (!supplierContractId) {
    return false;
  }

  if (
    Object.values(supplierContractsStore.allEntries())?.some((ei) => ei.id === supplierContractId)
  ) {
    return true;
  }
  // We explicitly do not await the loading here to allow the router to proceed immediately.
  // This enables the target component to handle and display its own loading and error states,
  // providing a better user experience (e.g., showing skeletons instead of a blank screen).
  supplierContractsStore.loadSingleEntry(supplierContractId);
  return true;
};
